module.exports = __webpack_public_path__ + "static/media/default-electric-meter.91ae38be.png";